import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { IUnauthHeaderProps } from '@r1-frontend/entities/Layout/Header/types';
import { useLeadGeneration } from '@r1-frontend/entities/Layout/Header/UnauthHeader/useLeadGeneration';
import { selectCompanyName } from '@r1-frontend/entities/stores/city/selectors';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { USER_LOGIN_ROUTE } from '@r1-frontend/shared/constants/routes';

import * as ST from './styled';

export interface IConnectionAndLoginBurgerViewProps {
    onOpenBecomeClientPopup: IUnauthHeaderProps['onBecomeClientHandler'],
    referrerPath: string,
    closeHandler?: () => void,
}

const BurgerView = ({
    onOpenBecomeClientPopup,
    referrerPath,
    closeHandler,
}: IConnectionAndLoginBurgerViewProps): JSX.Element => {
    const companyName = useSelector(selectCompanyName);
    const { showButton } = useLeadGeneration();

    const openConnectionPopup = () => {
        onOpenBecomeClientPopup('connect');
    };

    const sendAuthEvent = useCallback((action = 'Войти в личный кабинет') => {
        closeHandler && closeHandler();
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.mainMenuClick,
            action,
            label: 'menu_new',
        });
    }, [closeHandler]);

    return (
        <ST.ButtonsBlock>
            {showButton && (
                <ST.Button
                    type={btnTypes.ACCENT}
                    size={btnSizes.SMALL}
                    text={'Подключить ' + companyName}
                    onClick={openConnectionPopup}
                    isBurgerOpen={true}
                />
            )}
            <ST.Button
                type={btnTypes.SECONDARY}
                size={btnSizes.SMALL}
                href={USER_LOGIN_ROUTE + referrerPath}
                onClick={() => sendAuthEvent('Войти в личный кабинет')}
                isBurgerOpen={true}
            >
                <ST.Login data-test='lk-login-abn'>Войти</ST.Login>
            </ST.Button>
        </ST.ButtonsBlock>
    );
};

export default BurgerView;
